import React from 'react'
import Instructor from "../../../assets/Images/Instructor.png"
import HighlightText from './HighlightText'
import CTAButton from "../HomePage/Button"

const InstructorSection = () => {
  return (
    <div className='mt-16'>
      <div className='flex flex-col items-center gap-12 md:flex-row md:gap-20'>

        <div className='w-full max-w-md md:w-1/2'>
            <img
                src={Instructor}
                alt="Instructor teaching online"
                className='shadow-white shadow-[-1.3rem_-1rem_0_0]'
            />
        </div>

        <div className='flex w-full flex-col gap-8 md:w-1/2'>
            <div className='text-4xl font-semibold md:max-w-md'>
                Teach on{" "}
                <HighlightText text={"StudyNotion"} />
            </div>

            <p className='max-w-xl text-base font-medium text-richblack-300'>
            Publish structured courses, reach learners who are ready to practice,
            and use the same dashboard and media tools students already use — so
            you can focus on teaching.
            </p>

            <div className='w-fit'>
                <CTAButton active={true} linkto={"/signup"}>
                    Create instructor account
                </CTAButton>
            </div>

        </div>

      </div>
    </div>
  )
}

export default InstructorSection
